import TimeTracking, { type Props, type StateProps, type DispatchProps } from './view';

export default TimeTracking;
export type { Props, StateProps, DispatchProps };
